module.exports = __webpack_public_path__ + "media/assets/images/dropdown-arrow-022f9ab02cfb4233990bd968a1cdb083.svg";